import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

// Thank-you page. Spanish only, per requirements. Path is exactly "/thank_you".
export default function ThankYou() {
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = "es-AR";
      document.title = "Gracias — Argengeo";
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute(
        "content",
        "Su consulta fue recibida por el equipo de Argengeo. En breve nos pondremos en contacto."
      );
    }
  }, []);

  return (
    <div className="ag-thanks">
      <div className="ag-thanks__inner">
        <Link to="/" className="ag-thanks__brand" aria-label="Argengeo">
          <Logo />
        </Link>

        <div className="ag-thanks__badge" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h1 className="ag-thanks__title">¡Gracias por su consulta!</h1>
        <p className="ag-thanks__lede">
          Recibimos su mensaje y un especialista de Argengeo se pondrá en contacto en las próximas
          24 horas hábiles para enviarle el informe analítico introductorio y activar su acceso a la
          plataforma.
        </p>

        <ul className="ag-thanks__steps">
          <li>
            <span>01</span>
            <div>
              <h3>Revisión de la consulta</h3>
              <p>Nuestro equipo asigna un analista según el sector de su interés (litio, gas, petróleo o minería).</p>
            </div>
          </li>
          <li>
            <span>02</span>
            <div>
              <h3>Envío del material</h3>
              <p>Le enviaremos por correo electrónico el informe introductorio y las credenciales de acceso a la plataforma.</p>
            </div>
          </li>
          <li>
            <span>03</span>
            <div>
              <h3>Reunión opcional</h3>
              <p>Si lo desea, coordinamos una reunión virtual para responder sus preguntas sobre datos y proyectos publicados.</p>
            </div>
          </li>
        </ul>

        <Link to="/" className="ag-btn ag-btn--primary ag-btn--lg">
          Volver al inicio
        </Link>

        <p className="ag-thanks__meta">
          Argengeo Analytics S.R.L. · Av. Corrientes 1834, Piso 7, Oficina 704, CABA · CUIT
          30-71743198-5
        </p>
      </div>
    </div>
  );
}
